<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/manage/mode/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button
          type="primary"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setAddDefaultValue();
            getMaterialList();
          "
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row);
                getMaterialList();
              "
              >{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/material/manage/mode/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('guanlifangshi')" required>
            <yi_dictionary_select :type="'MATERIAL_MANAGE_MODE'" :ids.sync="yt.editObj.manageMode" @change="handleChange"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('guanlianpicifangan')" required>
            <el-select :disabled="materialBatchIdDisabled" :max="1" filterable :clearable="true" v-model="yt.editObj.materialBatchId">
              <el-option v-for="(item, index) in materialList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/manage/mode/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('guanlifangshi')" required>
            <yi_dictionary_select :type="'MATERIAL_MANAGE_MODE'" :ids.sync="yt.editObj.manageMode"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('guanlianpicifangan')" required>
            <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.materialBatchId">
              <el-option v-for="(item, index) in materialList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/manage/mode/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_base_matter_management_style',
  data() {
    return {
      materialList: [],
      materialBatchIdDisabled: true,
      columns: [
        {
          label: 'guanlifangshi',
          prop: 'manageMode',
          type: 'dictionary',
          key: 'MATERIAL_MANAGE_MODE'
        },
        {
          label: 'guanlianpicifangan',
          prop: 'materialBatch.name'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 120
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id,
        pageNum: 1,
        pageSize: 100
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
    }, 300);
  },
  methods: {
    beforeAdd(params, url) {
      params.materialId = this.$attrs.material.id;
      return params;
    },
    setAddDefaultValue() {
      this.yt.editObj.manageMode = '1';
    },
    async getMaterialList() {
      return await this.http
        .get(
          '/web/basic/material/batch/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999,
              isEnabled: 1
            })
        )
        .then(response => {
          this.materialList = response.data.rows || [];
        });
    },
    handleChange(value) {
      if (this.yt.editObj.manageMode === '2') {
        this.materialBatchIdDisabled = false;
      } else {
        this.materialBatchIdDisabled = true;
      }

      console.log('manageModeChange', this.yt.editObj.manageMode);
    }
  }
};
</script>

<style scoped lang="scss"></style>
